import { module } from 'angular';
import display from './builder/display.html';
import validate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/uri/display.html', display);
	$templateCache.put('kform/components/uri/validate.html', validate);
});
